import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { ZoneService } from 'src/app/services/zone.service';
import { GeofenceService } from "src/app/services/geofence.service";
import { GeofenceZoneService } from "src/app/services/geofencezone.service";

@Component({
  selector: "app-geofence-add-dialog",
  templateUrl: "./geofence-add-dialog.component.html",
  styleUrls: ["./geofence-add-dialog.component.scss"]
})
export class GeofenceAddDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  public zoneData: any;
  public selectedZone: any

  constructor(public dialogRef: MatDialogRef<GeofenceAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public geofenceService: GeofenceService,
    public geofenceZoneService: GeofenceZoneService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() {
    // this.getAllZone();
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    this.initlizeGeofenceAddForm();
  }

  initlizeGeofenceAddForm(): void {
    this.form = new FormGroup({
      geofenceName: new FormControl("", Validators.required),
      geofenceDesc: new FormControl("", Validators.required),
      // zone: new FormControl([], Validators.required),
      status: new FormControl(this.isStatus, Validators.required)
    });
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  addGeofenceZoneData(data): void{
    this.geofenceZoneService.addGeofenceZone(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        // console.log(response.data);
      }
    })
  }

  addGeofenceData(): void {
    let data = this.form.getRawValue();
    // this.selectedZone = data.zone;
    // delete data.zone;
    data.status = this.isStatus ? 1 : 3;
    this.geofenceService.addGeofence(data)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        // this.saveGeoFenceZone(response.data);
        this.toastrService.success(response.value, "Geofence Added Successfully!");
        this.dialogRef.close(true);
      } else {
        this.toastrService.error(response.value, "Failed To Load Data!")
      }
    });
  }

  saveGeoFenceZone(data: any){
    this.selectedZone.forEach(zoneid => {
      let payload = {
        geofenceId: data.id,
        zoneId: zoneid,
        organizationId: data.organizationId,
        status: data.status
      }
      this.addGeofenceZoneData(payload);
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}